
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as cercanXeoz2nC0TT9TNOF_wYwX1Rxj1Y_45uCdz2ZeJ8OUcwYEMeta } from "/app/pages/cerca.vue?macro=true";
import { default as agendaT7U4173aTQucYTJTl4kxrJy405vDfj04oxkFV1eB84UMeta } from "/app/pages/agenda.vue?macro=true";
import { default as carrello8i9hoUg7lmfUXqTv5XNTtSyt9D6m2pOKa9MEHpfaNFQMeta } from "/app/pages/carrello.vue?macro=true";
import { default as _91_46_46_46slug_93QkkyEDg6xOGuFkoxzFC_4565xuuMFULoZbO_183vt2UD8Meta } from "/app/pages/[...slug].vue?macro=true";
import { default as _91id_937Ggt5QXYzqzpGZ8k0daVC94U8lFiWKoEg8_45_45nMG3BYIMeta } from "/app/pages/node/[id].vue?macro=true";
import { default as mez1SStTsmtJwp3HvoqsiXLtRJfPv4SsH_45vVyeur_5AjQMeta } from "/app/pages/dashboard/me.vue?macro=true";
import { default as indexjWYnu92FKmz9Xbq02S2SL_Z6Soqdg4gVrBGywVnQwmgMeta } from "/app/pages/visita/index.vue?macro=true";
import { default as _91id_935RN1QA6BMCnlHRPo6opJPnOdj3PWs8BQEjZl3_45lYqqgMeta } from "/app/pages/l/eventi/[id].vue?macro=true";
import { default as _91id_93Ld_45mSn2IDf2Z_NfRSu1AelsSnW0YInMGsmfVAHDzLigMeta } from "/app/pages/l/pagine/[id].vue?macro=true";
import { default as index7PHmsvhFvB_g5kZxgiuxoeT0bdw2nPdkEwlj4tb_456q4Meta } from "/app/pages/checkout/index.vue?macro=true";
import { default as _91id_93LjsQXzBP1BVtNsLIa2zw3VTB_45gekku9c_45JRD8QdT0I4Meta } from "/app/pages/l/risorse/[id].vue?macro=true";
import { default as index_45F_uAQC8N4LTDgd1cq42C2ftJy11F_99xjd_45gOWaGcoMeta } from "/app/pages/dashboard/index.vue?macro=true";
import { default as _91id_93ExMsBNA1NSjnoRDEReTFIzIJbU7OzuNTs8bJrpqbvWwMeta } from "/app/pages/l/attivita/[id].vue?macro=true";
import { default as _91id_93jw0IagOBMfJV9VXBYXJK_TJ77JuykBxplCjmWovNuIEMeta } from "/app/pages/l/prodotti/[id].vue?macro=true";
import { default as _91id_93GG7NJQT36Gh_xufPmFaA_45l0HqIBLg7_jzk_45eQS6z_dYMeta } from "/app/pages/l/pacchetti/[id].vue?macro=true";
import { default as _91id_93vjZ_45wgy78Eor5ip89C1tn66P9s64IH109xqUVko2hnoMeta } from "/app/pages/l/spettacoli/[id].vue?macro=true";
import { default as _91id_93qxj8IIpZQgGuoKwfLh4_45yhYsjFW8DfKbNNlTS7qTdw8Meta } from "/app/pages/preview/eventi/[id].vue?macro=true";
import { default as _91id_93sBIe6EwiZGoBIe_pISef5UV_3Ohmh42yb_GO5IqsXDwMeta } from "/app/pages/preview/pagine/[id].vue?macro=true";
import { default as traduzione_45mancanteGO6sHAv41rQxDon27gg5galwatt7e8UOhVRDBqr8A5cMeta } from "/app/pages/traduzione-mancante.vue?macro=true";
import { default as _91id_93V1UoSyZQVOsLOzAJNPLkZ0IGUAGKntX0_45z3eGt9iiF0Meta } from "/app/pages/acquista/[tipo]/[id].vue?macro=true";
import { default as _91id_93j32lsNsqYEWq7qxuUcinB_7VEouforKHfG9rp6pLEOcMeta } from "/app/pages/acquista/bundle/[id].vue?macro=true";
import { default as _91id_93QmIdjfT8EpXjwCpRfVTKyAbaNM4CJzg5xyBtnUuc3CUMeta } from "/app/pages/preview/risorse/[id].vue?macro=true";
import { default as invitoNobclXKSNdWdJfNdkwWPvc4CumkFY_45wIPZI_myA9480Meta } from "/app/pages/registrazione/invito.vue?macro=true";
import { default as indexNMWrsrXOPyMGrmSfx6TzQQ2OcmBDYQXolFb0drJjtYUMeta } from "/app/pages/dashboard/login/index.vue?macro=true";
import { default as resetIp4UTnm9I4_svAHo1INFq8OIh6rVs1jqqhstJDhugygMeta } from "/app/pages/dashboard/login/reset.vue?macro=true";
import { default as maintenancevbLswyOn8R5L0tCcuSmMijKGNNg3_DjdT5yl57jg7a0Meta } from "/app/pages/dashboard/maintenance.vue?macro=true";
import { default as _91id_93Z3mbGWhG5SPrAbQQgcMC5zKcc2EN7dXArGP6rL_j74cMeta } from "/app/pages/l/visite_guidate/[id].vue?macro=true";
import { default as _91id_93eizVoq2yhoQtlFclReIY6TSpDtfMUgx6RdiITpNzBuIMeta } from "/app/pages/preview/attivita/[id].vue?macro=true";
import { default as _91id_93cVed9wSoXjCAdX37YVn5n_O3kYZATmpwRqR9gGDv6owMeta } from "/app/pages/preview/prodotti/[id].vue?macro=true";
import { default as forgot1aPxvUOYQeLbMI3RWbiHQHPvBQ7NN_45467TVpXXm3uDUMeta } from "/app/pages/dashboard/login/forgot.vue?macro=true";
import { default as _91id_93AHF2YVMRs6Mgy2XKIye3_51gq8qO88wqxG8_45bQgbgGoMeta } from "/app/pages/l/news_convention/[id].vue?macro=true";
import { default as _91id_93bsE9b013VuQ4AqzO2cnHjsuDaI_45W0UmyQfdXWTuS_r8Meta } from "/app/pages/preview/pacchetti/[id].vue?macro=true";
import { default as indexGNveKm1wYqz_45DkBiqtWxxIzQ6Ah8VKkWyDiuy3jqqCcMeta } from "/app/pages/dashboard/outdoor/index.vue?macro=true";
import { default as indexZDAGzcZjHZrG3Y_LT2lqbEB6uebTm7ZEHev85q01RC0Meta } from "/app/pages/dashboard/incoming/index.vue?macro=true";
import { default as _91ordine_93O1e5_JfQLmG1jbM7yaepWaaJakDIJMBigwbgtI4FqiAMeta } from "/app/pages/checkout/success/[ordine].vue?macro=true";
import { default as acquistaUw8LXHZrw_45PKhqcyedLEvvaU3RHh_45USqVBDWBZP9zmEMeta } from "/app/pages/dashboard/armonia/acquista.vue?macro=true";
import { default as gestisciMUoNhWTiFftOnvtbjhJTrCdfmsTUvDnm2wyGuAAVNHgMeta } from "/app/pages/dashboard/armonia/gestisci.vue?macro=true";
import { default as modificaNRjh_uSiJJ1SllDuVb_OdC2yiwd_45rdJbJwqs7ldNyxMMeta } from "/app/pages/dashboard/profilo/modifica.vue?macro=true";
import { default as _91id_93eQbiYmu69xcEy2mozHrCj30ZfmXhArF6m5iLd5HXX4wMeta } from "/app/pages/preview/visite-guidate/[id].vue?macro=true";
import { default as _91id_93sJpcgGK2QWM74k5Cxqf1IHDPPnA1y54SehO3JXOwmTIMeta } from "/app/pages/acquista/visite-guidate/[id].vue?macro=true";
import { default as indexuZXg34bwRJGQqzbzcjj5aHcOksFjYUKAH5uczlZfQgIMeta } from "/app/pages/dashboard/outdoor/crea/index.vue?macro=true";
import { default as indexJsvT5MfJKKscvldptkOwmS60K4UejJahylTZFhLiCqcMeta } from "/app/pages/dashboard/profilo/card/index.vue?macro=true";
import { default as indexzxS5GuoxZU6ab_45ZUsPpXt890c4BOvaadaANB_45axf8KQMeta } from "/app/pages/dashboard/ristorazione/index.vue?macro=true";
import { default as index7PjbNfdY0eWxSnTIQINeYxWju10mEncmzKJXEj7zYGgMeta } from "/app/pages/dashboard/incoming/crea/index.vue?macro=true";
import { default as index090OEqY3H7jmu9WydSTaehvMk_45ETkWf0oUPeZ7mH_i4Meta } from "/app/pages/dashboard/registrazione/index.vue?macro=true";
import { default as indexpWSeSu5WAhaFDqdZeJkTIZfoV57ghMapcly4PPpI4_sMeta } from "/app/pages/dashboard/profilo/ordini/index.vue?macro=true";
import { default as invitoYHCrz9cMgdY8L8uYULXFvMG201RoPZ5P3nkRRahx5_gMeta } from "/app/pages/dashboard/registrazione/invito.vue?macro=true";
import { default as _91id_93i5iDRy9p35dv7Lw2vSFh76Kj2584PWpTH2U3Ah7OsIMMeta } from "/app/pages/dashboard/outdoor/modifica/[id].vue?macro=true";
import { default as registrazionesGr6cHhZl_4534aEMq_45jvFhl6uvNK9OscVccniv9YRtngMeta } from "/app/pages/dashboard/outdoor/registrazione.vue?macro=true";
import { default as indexcjx7ciOILeQTuudkuPC3lQDT9BvpOWzKJpT10sJPAsEMeta } from "/app/pages/dashboard/promuovi-evento/index.vue?macro=true";
import { default as _91id_93C5BpebK0RHL_459mJtiNJNKx7K6StOzUdUVf2zdaBRarwMeta } from "/app/pages/dashboard/incoming/modifica/[id].vue?macro=true";
import { default as registrazioneKWBvm72vcv928pUpijnzlspZvxaG9TWV1yVTPivGtZgMeta } from "/app/pages/dashboard/incoming/registrazione.vue?macro=true";
import { default as indexhpVaVoyr_45HQACHzWF3l9Ax7Gu7Dp1gxR_crfBy6yIRgMeta } from "/app/pages/dashboard/ristorazione/crea/index.vue?macro=true";
import { default as indexNtHfHEbp109rCGC2oWk19noF_W9D0X_4YlZ9_45kr3N8QMeta } from "/app/pages/dashboard/armonia/calendario/index.vue?macro=true";
import { default as indexzy0Z5TIuNXyZtMO7BOVHoLEnAy6fUeVaEHaRuI4COakMeta } from "/app/pages/dashboard/profilo/prenotazioni/index.vue?macro=true";
import { default as _91id_93usKGIZYdH4_GwYYv_45EU9SPaT9OEVUsPGcTEOljIa9qsMeta } from "/app/pages/dashboard/ristorazione/modifica/[id].vue?macro=true";
import { default as indexeRP9E5BCdVM39ttJXmipgIEgEg6tQnlO6i1kQ_FGAPUMeta } from "/app/pages/dashboard/promuovi-ristorazione/index.vue?macro=true";
import { default as index3ImPngfz2pBa4PmemWXEaRhmiy_45FNM8_45fq4MGzL_j0EMeta } from "/app/pages/dashboard/armonia/calendario/[slug]/index.vue?macro=true";
import { default as prenotaarVHd9wjZMlqbbJxRWperwS4nQg4QFTffz6cUZPU6EcMeta } from "/app/pages/dashboard/armonia/calendario/[slug]/prenota.vue?macro=true";
import { default as _91id_93psCsL8yaQJ4maGJW3FN_45k5Au1iVbkiLGwLv6Kw_Fv1MMeta } from "/app/pages/dashboard/profilo/card/abbonamenti-athena/[id].vue?macro=true";
import { default as torino_45piemonte_45cardgl5EmiXCFD1YDSOt4JYBv2cCqm1PUfBMsdrR2LheVo4Meta } from "/app/pages/visita/pianifica-la-tua-visita/torino-piemonte-card.vue?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "cerca___it",
    path: "/it/cerca",
    component: () => import("/app/pages/cerca.vue")
  },
  {
    name: "cerca___en",
    path: "/en/cerca",
    component: () => import("/app/pages/cerca.vue")
  },
  {
    name: "cerca___fr",
    path: "/fr/cerca",
    component: () => import("/app/pages/cerca.vue")
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "agenda___it",
    path: "/it/agenda",
    meta: agendaT7U4173aTQucYTJTl4kxrJy405vDfj04oxkFV1eB84UMeta || {},
    component: () => import("/app/pages/agenda.vue")
  },
  {
    name: "agenda___en",
    path: "/en/agenda",
    meta: agendaT7U4173aTQucYTJTl4kxrJy405vDfj04oxkFV1eB84UMeta || {},
    component: () => import("/app/pages/agenda.vue")
  },
  {
    name: "agenda___fr",
    path: "/fr/agenda",
    meta: agendaT7U4173aTQucYTJTl4kxrJy405vDfj04oxkFV1eB84UMeta || {},
    component: () => import("/app/pages/agenda.vue")
  },
  {
    name: "carrello___it",
    path: "/it/carrello",
    meta: {"middleware":["carrello"]},
    component: () => import("/app/pages/carrello.vue")
  },
  {
    name: "carrello___en",
    path: "/en/carrello",
    meta: {"middleware":["carrello"]},
    component: () => import("/app/pages/carrello.vue")
  },
  {
    name: "carrello___fr",
    path: "/fr/carrello",
    meta: {"middleware":["carrello"]},
    component: () => import("/app/pages/carrello.vue")
  },
  {
    name: "slug___it",
    path: "/it/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___fr",
    path: "/fr/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "node-id___it",
    path: "/it/node/:id()",
    component: () => import("/app/pages/node/[id].vue")
  },
  {
    name: "node-id___en",
    path: "/en/node/:id()",
    component: () => import("/app/pages/node/[id].vue")
  },
  {
    name: "node-id___fr",
    path: "/fr/node/:id()",
    component: () => import("/app/pages/node/[id].vue")
  },
  {
    name: "dashboard-me___it",
    path: "/it/dashboard/me",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/me.vue")
  },
  {
    name: "dashboard-me___en",
    path: "/en/dashboard/me",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/me.vue")
  },
  {
    name: "dashboard-me___fr",
    path: "/fr/dashboard/me",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/me.vue")
  },
  {
    name: "visita___it",
    path: "/it/visita",
    meta: indexjWYnu92FKmz9Xbq02S2SL_Z6Soqdg4gVrBGywVnQwmgMeta || {},
    component: () => import("/app/pages/visita/index.vue")
  },
  {
    name: "visita___en",
    path: "/en/visit",
    meta: indexjWYnu92FKmz9Xbq02S2SL_Z6Soqdg4gVrBGywVnQwmgMeta || {},
    component: () => import("/app/pages/visita/index.vue")
  },
  {
    name: "visita___fr",
    path: "/fr/decouvrir",
    meta: indexjWYnu92FKmz9Xbq02S2SL_Z6Soqdg4gVrBGywVnQwmgMeta || {},
    component: () => import("/app/pages/visita/index.vue")
  },
  {
    name: "l-eventi-id___it",
    path: "/it/l/eventi/:id()",
    component: () => import("/app/pages/l/eventi/[id].vue")
  },
  {
    name: "l-eventi-id___en",
    path: "/en/l/eventi/:id()",
    component: () => import("/app/pages/l/eventi/[id].vue")
  },
  {
    name: "l-eventi-id___fr",
    path: "/fr/l/eventi/:id()",
    component: () => import("/app/pages/l/eventi/[id].vue")
  },
  {
    name: "l-pagine-id___it",
    path: "/it/l/pagine/:id()",
    component: () => import("/app/pages/l/pagine/[id].vue")
  },
  {
    name: "l-pagine-id___en",
    path: "/en/l/pagine/:id()",
    component: () => import("/app/pages/l/pagine/[id].vue")
  },
  {
    name: "l-pagine-id___fr",
    path: "/fr/l/pagine/:id()",
    component: () => import("/app/pages/l/pagine/[id].vue")
  },
  {
    name: "checkout___it",
    path: "/it/checkout",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/checkout/index.vue")
  },
  {
    name: "checkout___en",
    path: "/en/checkout",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/checkout/index.vue")
  },
  {
    name: "checkout___fr",
    path: "/fr/checkout",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/checkout/index.vue")
  },
  {
    name: "l-risorse-id___it",
    path: "/it/l/risorse/:id()",
    component: () => import("/app/pages/l/risorse/[id].vue")
  },
  {
    name: "l-risorse-id___en",
    path: "/en/l/risorse/:id()",
    component: () => import("/app/pages/l/risorse/[id].vue")
  },
  {
    name: "l-risorse-id___fr",
    path: "/fr/l/risorse/:id()",
    component: () => import("/app/pages/l/risorse/[id].vue")
  },
  {
    name: "dashboard___it",
    path: "/it/dashboard",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/index.vue")
  },
  {
    name: "dashboard___en",
    path: "/en/dashboard",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/index.vue")
  },
  {
    name: "dashboard___fr",
    path: "/fr/dashboard",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/index.vue")
  },
  {
    name: "l-attivita-id___it",
    path: "/it/l/attivita/:id()",
    component: () => import("/app/pages/l/attivita/[id].vue")
  },
  {
    name: "l-attivita-id___en",
    path: "/en/l/attivita/:id()",
    component: () => import("/app/pages/l/attivita/[id].vue")
  },
  {
    name: "l-attivita-id___fr",
    path: "/fr/l/attivita/:id()",
    component: () => import("/app/pages/l/attivita/[id].vue")
  },
  {
    name: "l-prodotti-id___it",
    path: "/it/l/prodotti/:id()",
    component: () => import("/app/pages/l/prodotti/[id].vue")
  },
  {
    name: "l-prodotti-id___en",
    path: "/en/l/prodotti/:id()",
    component: () => import("/app/pages/l/prodotti/[id].vue")
  },
  {
    name: "l-prodotti-id___fr",
    path: "/fr/l/prodotti/:id()",
    component: () => import("/app/pages/l/prodotti/[id].vue")
  },
  {
    name: "l-pacchetti-id___it",
    path: "/it/l/pacchetti/:id()",
    component: () => import("/app/pages/l/pacchetti/[id].vue")
  },
  {
    name: "l-pacchetti-id___en",
    path: "/en/l/pacchetti/:id()",
    component: () => import("/app/pages/l/pacchetti/[id].vue")
  },
  {
    name: "l-pacchetti-id___fr",
    path: "/fr/l/pacchetti/:id()",
    component: () => import("/app/pages/l/pacchetti/[id].vue")
  },
  {
    name: "l-spettacoli-id___it",
    path: "/it/l/spettacoli/:id()",
    component: () => import("/app/pages/l/spettacoli/[id].vue")
  },
  {
    name: "l-spettacoli-id___en",
    path: "/en/l/spettacoli/:id()",
    component: () => import("/app/pages/l/spettacoli/[id].vue")
  },
  {
    name: "l-spettacoli-id___fr",
    path: "/fr/l/spettacoli/:id()",
    component: () => import("/app/pages/l/spettacoli/[id].vue")
  },
  {
    name: "preview-eventi-id___it",
    path: "/it/preview/eventi/:id()",
    component: () => import("/app/pages/preview/eventi/[id].vue")
  },
  {
    name: "preview-eventi-id___en",
    path: "/en/preview/eventi/:id()",
    component: () => import("/app/pages/preview/eventi/[id].vue")
  },
  {
    name: "preview-eventi-id___fr",
    path: "/fr/preview/eventi/:id()",
    component: () => import("/app/pages/preview/eventi/[id].vue")
  },
  {
    name: "preview-pagine-id___it",
    path: "/it/preview/pagine/:id()",
    component: () => import("/app/pages/preview/pagine/[id].vue")
  },
  {
    name: "preview-pagine-id___en",
    path: "/en/preview/pagine/:id()",
    component: () => import("/app/pages/preview/pagine/[id].vue")
  },
  {
    name: "preview-pagine-id___fr",
    path: "/fr/preview/pagine/:id()",
    component: () => import("/app/pages/preview/pagine/[id].vue")
  },
  {
    name: "traduzione-mancante___it",
    path: "/it/traduzione-mancante",
    component: () => import("/app/pages/traduzione-mancante.vue")
  },
  {
    name: "traduzione-mancante___en",
    path: "/en/missing-translation",
    component: () => import("/app/pages/traduzione-mancante.vue")
  },
  {
    name: "traduzione-mancante___fr",
    path: "/fr/traduction-manquante",
    component: () => import("/app/pages/traduzione-mancante.vue")
  },
  {
    name: "acquista-tipo-id___it",
    path: "/it/acquista/:tipo()/:id()",
    meta: {"middleware":["acquista-prodotto"]},
    component: () => import("/app/pages/acquista/[tipo]/[id].vue")
  },
  {
    name: "acquista-tipo-id___en",
    path: "/en/acquista/:tipo()/:id()",
    meta: {"middleware":["acquista-prodotto"]},
    component: () => import("/app/pages/acquista/[tipo]/[id].vue")
  },
  {
    name: "acquista-tipo-id___fr",
    path: "/fr/acquista/:tipo()/:id()",
    meta: {"middleware":["acquista-prodotto"]},
    component: () => import("/app/pages/acquista/[tipo]/[id].vue")
  },
  {
    name: "acquista-bundle-id___it",
    path: "/it/acquista/bundle/:id()",
    component: () => import("/app/pages/acquista/bundle/[id].vue")
  },
  {
    name: "acquista-bundle-id___en",
    path: "/en/acquista/bundle/:id()",
    component: () => import("/app/pages/acquista/bundle/[id].vue")
  },
  {
    name: "acquista-bundle-id___fr",
    path: "/fr/acquista/bundle/:id()",
    component: () => import("/app/pages/acquista/bundle/[id].vue")
  },
  {
    name: "preview-risorse-id___it",
    path: "/it/preview/risorse/:id()",
    component: () => import("/app/pages/preview/risorse/[id].vue")
  },
  {
    name: "preview-risorse-id___en",
    path: "/en/preview/risorse/:id()",
    component: () => import("/app/pages/preview/risorse/[id].vue")
  },
  {
    name: "preview-risorse-id___fr",
    path: "/fr/preview/risorse/:id()",
    component: () => import("/app/pages/preview/risorse/[id].vue")
  },
  {
    name: "registrazione-invito___it",
    path: "/it/registrazione/invito",
    meta: invitoNobclXKSNdWdJfNdkwWPvc4CumkFY_45wIPZI_myA9480Meta || {},
    component: () => import("/app/pages/registrazione/invito.vue")
  },
  {
    name: "registrazione-invito___en",
    path: "/en/registrazione/invito",
    meta: invitoNobclXKSNdWdJfNdkwWPvc4CumkFY_45wIPZI_myA9480Meta || {},
    component: () => import("/app/pages/registrazione/invito.vue")
  },
  {
    name: "registrazione-invito___fr",
    path: "/fr/registrazione/invito",
    meta: invitoNobclXKSNdWdJfNdkwWPvc4CumkFY_45wIPZI_myA9480Meta || {},
    component: () => import("/app/pages/registrazione/invito.vue")
  },
  {
    name: "dashboard-login___it",
    path: "/it/dashboard/login",
    component: () => import("/app/pages/dashboard/login/index.vue")
  },
  {
    name: "dashboard-login___en",
    path: "/en/dashboard/login",
    component: () => import("/app/pages/dashboard/login/index.vue")
  },
  {
    name: "dashboard-login___fr",
    path: "/fr/dashboard/login",
    component: () => import("/app/pages/dashboard/login/index.vue")
  },
  {
    name: "dashboard-login-reset___it",
    path: "/it/dashboard/login/reset",
    meta: {"middleware":["reset-password"]},
    component: () => import("/app/pages/dashboard/login/reset.vue")
  },
  {
    name: "dashboard-login-reset___en",
    path: "/en/dashboard/login/reset",
    meta: {"middleware":["reset-password"]},
    component: () => import("/app/pages/dashboard/login/reset.vue")
  },
  {
    name: "dashboard-login-reset___fr",
    path: "/fr/dashboard/login/reset",
    meta: {"middleware":["reset-password"]},
    component: () => import("/app/pages/dashboard/login/reset.vue")
  },
  {
    name: "dashboard-maintenance___it",
    path: "/it/dashboard/maintenance",
    meta: maintenancevbLswyOn8R5L0tCcuSmMijKGNNg3_DjdT5yl57jg7a0Meta || {},
    component: () => import("/app/pages/dashboard/maintenance.vue")
  },
  {
    name: "dashboard-maintenance___en",
    path: "/en/dashboard/maintenance",
    meta: maintenancevbLswyOn8R5L0tCcuSmMijKGNNg3_DjdT5yl57jg7a0Meta || {},
    component: () => import("/app/pages/dashboard/maintenance.vue")
  },
  {
    name: "dashboard-maintenance___fr",
    path: "/fr/dashboard/maintenance",
    meta: maintenancevbLswyOn8R5L0tCcuSmMijKGNNg3_DjdT5yl57jg7a0Meta || {},
    component: () => import("/app/pages/dashboard/maintenance.vue")
  },
  {
    name: "l-visite_guidate-id___it",
    path: "/it/l/visite_guidate/:id()",
    component: () => import("/app/pages/l/visite_guidate/[id].vue")
  },
  {
    name: "l-visite_guidate-id___en",
    path: "/en/l/visite_guidate/:id()",
    component: () => import("/app/pages/l/visite_guidate/[id].vue")
  },
  {
    name: "l-visite_guidate-id___fr",
    path: "/fr/l/visite_guidate/:id()",
    component: () => import("/app/pages/l/visite_guidate/[id].vue")
  },
  {
    name: "preview-attivita-id___it",
    path: "/it/preview/attivita/:id()",
    component: () => import("/app/pages/preview/attivita/[id].vue")
  },
  {
    name: "preview-attivita-id___en",
    path: "/en/preview/attivita/:id()",
    component: () => import("/app/pages/preview/attivita/[id].vue")
  },
  {
    name: "preview-attivita-id___fr",
    path: "/fr/preview/attivita/:id()",
    component: () => import("/app/pages/preview/attivita/[id].vue")
  },
  {
    name: "preview-prodotti-id___it",
    path: "/it/preview/prodotti/:id()",
    component: () => import("/app/pages/preview/prodotti/[id].vue")
  },
  {
    name: "preview-prodotti-id___en",
    path: "/en/preview/prodotti/:id()",
    component: () => import("/app/pages/preview/prodotti/[id].vue")
  },
  {
    name: "preview-prodotti-id___fr",
    path: "/fr/preview/prodotti/:id()",
    component: () => import("/app/pages/preview/prodotti/[id].vue")
  },
  {
    name: "dashboard-login-forgot___it",
    path: "/it/dashboard/login/forgot",
    component: () => import("/app/pages/dashboard/login/forgot.vue")
  },
  {
    name: "dashboard-login-forgot___en",
    path: "/en/dashboard/login/forgot",
    component: () => import("/app/pages/dashboard/login/forgot.vue")
  },
  {
    name: "dashboard-login-forgot___fr",
    path: "/fr/dashboard/login/forgot",
    component: () => import("/app/pages/dashboard/login/forgot.vue")
  },
  {
    name: "l-news_convention-id___it",
    path: "/it/l/news_convention/:id()",
    component: () => import("/app/pages/l/news_convention/[id].vue")
  },
  {
    name: "l-news_convention-id___en",
    path: "/en/l/news_convention/:id()",
    component: () => import("/app/pages/l/news_convention/[id].vue")
  },
  {
    name: "l-news_convention-id___fr",
    path: "/fr/l/news_convention/:id()",
    component: () => import("/app/pages/l/news_convention/[id].vue")
  },
  {
    name: "preview-pacchetti-id___it",
    path: "/it/preview/pacchetti/:id()",
    component: () => import("/app/pages/preview/pacchetti/[id].vue")
  },
  {
    name: "preview-pacchetti-id___en",
    path: "/en/preview/pacchetti/:id()",
    component: () => import("/app/pages/preview/pacchetti/[id].vue")
  },
  {
    name: "preview-pacchetti-id___fr",
    path: "/fr/preview/pacchetti/:id()",
    component: () => import("/app/pages/preview/pacchetti/[id].vue")
  },
  {
    name: "dashboard-outdoor___it",
    path: "/it/dashboard/outdoor",
    meta: {"middleware":["private-area-operatori-outdoor"]},
    component: () => import("/app/pages/dashboard/outdoor/index.vue")
  },
  {
    name: "dashboard-outdoor___en",
    path: "/en/dashboard/outdoor",
    meta: {"middleware":["private-area-operatori-outdoor"]},
    component: () => import("/app/pages/dashboard/outdoor/index.vue")
  },
  {
    name: "dashboard-outdoor___fr",
    path: "/fr/dashboard/outdoor",
    meta: {"middleware":["private-area-operatori-outdoor"]},
    component: () => import("/app/pages/dashboard/outdoor/index.vue")
  },
  {
    name: "dashboard-incoming___it",
    path: "/it/dashboard/incoming",
    meta: {"middleware":["private-area-operatori-incoming"]},
    component: () => import("/app/pages/dashboard/incoming/index.vue")
  },
  {
    name: "dashboard-incoming___en",
    path: "/en/dashboard/incoming",
    meta: {"middleware":["private-area-operatori-incoming"]},
    component: () => import("/app/pages/dashboard/incoming/index.vue")
  },
  {
    name: "dashboard-incoming___fr",
    path: "/fr/dashboard/incoming",
    meta: {"middleware":["private-area-operatori-incoming"]},
    component: () => import("/app/pages/dashboard/incoming/index.vue")
  },
  {
    name: "checkout-success-ordine___it",
    path: "/it/checkout/success/:ordine()",
    component: () => import("/app/pages/checkout/success/[ordine].vue")
  },
  {
    name: "checkout-success-ordine___en",
    path: "/en/checkout/success/:ordine()",
    component: () => import("/app/pages/checkout/success/[ordine].vue")
  },
  {
    name: "checkout-success-ordine___fr",
    path: "/fr/checkout/success/:ordine()",
    component: () => import("/app/pages/checkout/success/[ordine].vue")
  },
  {
    name: "dashboard-armonia-acquista___it",
    path: "/it/dashboard/armonia/acquista",
    component: () => import("/app/pages/dashboard/armonia/acquista.vue")
  },
  {
    name: "dashboard-armonia-acquista___en",
    path: "/en/dashboard/armonia/acquista",
    component: () => import("/app/pages/dashboard/armonia/acquista.vue")
  },
  {
    name: "dashboard-armonia-acquista___fr",
    path: "/fr/dashboard/armonia/acquista",
    component: () => import("/app/pages/dashboard/armonia/acquista.vue")
  },
  {
    name: "dashboard-armonia-gestisci___it",
    path: "/it/dashboard/armonia/gestisci",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/armonia/gestisci.vue")
  },
  {
    name: "dashboard-armonia-gestisci___en",
    path: "/en/dashboard/armonia/gestisci",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/armonia/gestisci.vue")
  },
  {
    name: "dashboard-armonia-gestisci___fr",
    path: "/fr/dashboard/armonia/gestisci",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/armonia/gestisci.vue")
  },
  {
    name: "dashboard-profilo-modifica___it",
    path: "/it/dashboard/profilo/modifica",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/profilo/modifica.vue")
  },
  {
    name: "dashboard-profilo-modifica___en",
    path: "/en/dashboard/profilo/modifica",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/profilo/modifica.vue")
  },
  {
    name: "dashboard-profilo-modifica___fr",
    path: "/fr/dashboard/profilo/modifica",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/profilo/modifica.vue")
  },
  {
    name: "preview-visite-guidate-id___it",
    path: "/it/preview/visite-guidate/:id()",
    component: () => import("/app/pages/preview/visite-guidate/[id].vue")
  },
  {
    name: "preview-visite-guidate-id___en",
    path: "/en/preview/visite-guidate/:id()",
    component: () => import("/app/pages/preview/visite-guidate/[id].vue")
  },
  {
    name: "preview-visite-guidate-id___fr",
    path: "/fr/preview/visite-guidate/:id()",
    component: () => import("/app/pages/preview/visite-guidate/[id].vue")
  },
  {
    name: "acquista-visite-guidate-id___it",
    path: "/it/acquista/visite-guidate/:id()",
    component: () => import("/app/pages/acquista/visite-guidate/[id].vue")
  },
  {
    name: "acquista-visite-guidate-id___en",
    path: "/en/acquista/visite-guidate/:id()",
    component: () => import("/app/pages/acquista/visite-guidate/[id].vue")
  },
  {
    name: "acquista-visite-guidate-id___fr",
    path: "/fr/acquista/visite-guidate/:id()",
    component: () => import("/app/pages/acquista/visite-guidate/[id].vue")
  },
  {
    name: "dashboard-outdoor-crea___it",
    path: "/it/dashboard/outdoor/crea",
    meta: {"middleware":["private-area-operatori-outdoor"]},
    component: () => import("/app/pages/dashboard/outdoor/crea/index.vue")
  },
  {
    name: "dashboard-outdoor-crea___en",
    path: "/en/dashboard/outdoor/crea",
    meta: {"middleware":["private-area-operatori-outdoor"]},
    component: () => import("/app/pages/dashboard/outdoor/crea/index.vue")
  },
  {
    name: "dashboard-outdoor-crea___fr",
    path: "/fr/dashboard/outdoor/crea",
    meta: {"middleware":["private-area-operatori-outdoor"]},
    component: () => import("/app/pages/dashboard/outdoor/crea/index.vue")
  },
  {
    name: "dashboard-profilo-card___it",
    path: "/it/dashboard/profilo/card",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/profilo/card/index.vue")
  },
  {
    name: "dashboard-profilo-card___en",
    path: "/en/dashboard/profilo/card",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/profilo/card/index.vue")
  },
  {
    name: "dashboard-profilo-card___fr",
    path: "/fr/dashboard/profilo/card",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/profilo/card/index.vue")
  },
  {
    name: "dashboard-ristorazione___it",
    path: "/it/dashboard/ristorazione",
    meta: {"middleware":["private-area-ristoratori"]},
    component: () => import("/app/pages/dashboard/ristorazione/index.vue")
  },
  {
    name: "dashboard-ristorazione___en",
    path: "/en/dashboard/ristorazione",
    meta: {"middleware":["private-area-ristoratori"]},
    component: () => import("/app/pages/dashboard/ristorazione/index.vue")
  },
  {
    name: "dashboard-ristorazione___fr",
    path: "/fr/dashboard/ristorazione",
    meta: {"middleware":["private-area-ristoratori"]},
    component: () => import("/app/pages/dashboard/ristorazione/index.vue")
  },
  {
    name: "dashboard-incoming-crea___it",
    path: "/it/dashboard/incoming/crea",
    meta: {"middleware":["private-area-operatori-incoming"]},
    component: () => import("/app/pages/dashboard/incoming/crea/index.vue")
  },
  {
    name: "dashboard-incoming-crea___en",
    path: "/en/dashboard/incoming/crea",
    meta: {"middleware":["private-area-operatori-incoming"]},
    component: () => import("/app/pages/dashboard/incoming/crea/index.vue")
  },
  {
    name: "dashboard-incoming-crea___fr",
    path: "/fr/dashboard/incoming/crea",
    meta: {"middleware":["private-area-operatori-incoming"]},
    component: () => import("/app/pages/dashboard/incoming/crea/index.vue")
  },
  {
    name: "dashboard-registrazione___it",
    path: "/it/dashboard/registrazione",
    component: () => import("/app/pages/dashboard/registrazione/index.vue")
  },
  {
    name: "dashboard-registrazione___en",
    path: "/en/dashboard/registrazione",
    component: () => import("/app/pages/dashboard/registrazione/index.vue")
  },
  {
    name: "dashboard-registrazione___fr",
    path: "/fr/dashboard/registrazione",
    component: () => import("/app/pages/dashboard/registrazione/index.vue")
  },
  {
    name: "dashboard-profilo-ordini___it",
    path: "/it/dashboard/profilo/ordini",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/profilo/ordini/index.vue")
  },
  {
    name: "dashboard-profilo-ordini___en",
    path: "/en/dashboard/profilo/ordini",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/profilo/ordini/index.vue")
  },
  {
    name: "dashboard-profilo-ordini___fr",
    path: "/fr/dashboard/profilo/ordini",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/profilo/ordini/index.vue")
  },
  {
    name: "dashboard-registrazione-invito___it",
    path: "/it/dashboard/registrazione/invito",
    meta: {"middleware":["registra-invito"]},
    component: () => import("/app/pages/dashboard/registrazione/invito.vue")
  },
  {
    name: "dashboard-registrazione-invito___en",
    path: "/en/dashboard/registrazione/invito",
    meta: {"middleware":["registra-invito"]},
    component: () => import("/app/pages/dashboard/registrazione/invito.vue")
  },
  {
    name: "dashboard-registrazione-invito___fr",
    path: "/fr/dashboard/registrazione/invito",
    meta: {"middleware":["registra-invito"]},
    component: () => import("/app/pages/dashboard/registrazione/invito.vue")
  },
  {
    name: "dashboard-outdoor-modifica-id___it",
    path: "/it/dashboard/outdoor/modifica/:id()",
    meta: {"middleware":["private-area-operatori-outdoor"]},
    component: () => import("/app/pages/dashboard/outdoor/modifica/[id].vue")
  },
  {
    name: "dashboard-outdoor-modifica-id___en",
    path: "/en/dashboard/outdoor/modifica/:id()",
    meta: {"middleware":["private-area-operatori-outdoor"]},
    component: () => import("/app/pages/dashboard/outdoor/modifica/[id].vue")
  },
  {
    name: "dashboard-outdoor-modifica-id___fr",
    path: "/fr/dashboard/outdoor/modifica/:id()",
    meta: {"middleware":["private-area-operatori-outdoor"]},
    component: () => import("/app/pages/dashboard/outdoor/modifica/[id].vue")
  },
  {
    name: "dashboard-outdoor-registrazione___it",
    path: "/it/dashboard/outdoor/registrazione",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/outdoor/registrazione.vue")
  },
  {
    name: "dashboard-outdoor-registrazione___en",
    path: "/en/dashboard/outdoor/registrazione",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/outdoor/registrazione.vue")
  },
  {
    name: "dashboard-outdoor-registrazione___fr",
    path: "/fr/dashboard/outdoor/registrazione",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/outdoor/registrazione.vue")
  },
  {
    name: "dashboard-promuovi-evento___it",
    path: "/it/dashboard/promuovi-evento",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/promuovi-evento/index.vue")
  },
  {
    name: "dashboard-promuovi-evento___en",
    path: "/en/dashboard/promuovi-evento",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/promuovi-evento/index.vue")
  },
  {
    name: "dashboard-promuovi-evento___fr",
    path: "/fr/dashboard/promuovi-evento",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/promuovi-evento/index.vue")
  },
  {
    name: "dashboard-incoming-modifica-id___it",
    path: "/it/dashboard/incoming/modifica/:id()",
    meta: {"middleware":["private-area-operatori-incoming"]},
    component: () => import("/app/pages/dashboard/incoming/modifica/[id].vue")
  },
  {
    name: "dashboard-incoming-modifica-id___en",
    path: "/en/dashboard/incoming/modifica/:id()",
    meta: {"middleware":["private-area-operatori-incoming"]},
    component: () => import("/app/pages/dashboard/incoming/modifica/[id].vue")
  },
  {
    name: "dashboard-incoming-modifica-id___fr",
    path: "/fr/dashboard/incoming/modifica/:id()",
    meta: {"middleware":["private-area-operatori-incoming"]},
    component: () => import("/app/pages/dashboard/incoming/modifica/[id].vue")
  },
  {
    name: "dashboard-incoming-registrazione___it",
    path: "/it/dashboard/incoming/registrazione",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/incoming/registrazione.vue")
  },
  {
    name: "dashboard-incoming-registrazione___en",
    path: "/en/dashboard/incoming/registrazione",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/incoming/registrazione.vue")
  },
  {
    name: "dashboard-incoming-registrazione___fr",
    path: "/fr/dashboard/incoming/registrazione",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/incoming/registrazione.vue")
  },
  {
    name: "dashboard-ristorazione-crea___it",
    path: "/it/dashboard/ristorazione/crea",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/ristorazione/crea/index.vue")
  },
  {
    name: "dashboard-ristorazione-crea___en",
    path: "/en/dashboard/ristorazione/crea",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/ristorazione/crea/index.vue")
  },
  {
    name: "dashboard-ristorazione-crea___fr",
    path: "/fr/dashboard/ristorazione/crea",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/ristorazione/crea/index.vue")
  },
  {
    name: "dashboard-armonia-calendario___it",
    path: "/it/dashboard/armonia/calendario",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/armonia/calendario/index.vue")
  },
  {
    name: "dashboard-armonia-calendario___en",
    path: "/en/dashboard/armonia/calendario",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/armonia/calendario/index.vue")
  },
  {
    name: "dashboard-armonia-calendario___fr",
    path: "/fr/dashboard/armonia/calendario",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/armonia/calendario/index.vue")
  },
  {
    name: "dashboard-profilo-prenotazioni___it",
    path: "/it/dashboard/profilo/prenotazioni",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/profilo/prenotazioni/index.vue")
  },
  {
    name: "dashboard-profilo-prenotazioni___en",
    path: "/en/dashboard/profilo/prenotazioni",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/profilo/prenotazioni/index.vue")
  },
  {
    name: "dashboard-profilo-prenotazioni___fr",
    path: "/fr/dashboard/profilo/prenotazioni",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/profilo/prenotazioni/index.vue")
  },
  {
    name: "dashboard-ristorazione-modifica-id___it",
    path: "/it/dashboard/ristorazione/modifica/:id()",
    meta: {"middleware":["private-area-ristoratori"]},
    component: () => import("/app/pages/dashboard/ristorazione/modifica/[id].vue")
  },
  {
    name: "dashboard-ristorazione-modifica-id___en",
    path: "/en/dashboard/ristorazione/modifica/:id()",
    meta: {"middleware":["private-area-ristoratori"]},
    component: () => import("/app/pages/dashboard/ristorazione/modifica/[id].vue")
  },
  {
    name: "dashboard-ristorazione-modifica-id___fr",
    path: "/fr/dashboard/ristorazione/modifica/:id()",
    meta: {"middleware":["private-area-ristoratori"]},
    component: () => import("/app/pages/dashboard/ristorazione/modifica/[id].vue")
  },
  {
    name: "dashboard-promuovi-ristorazione___it",
    path: "/it/dashboard/promuovi-ristorazione",
    meta: indexeRP9E5BCdVM39ttJXmipgIEgEg6tQnlO6i1kQ_FGAPUMeta || {},
    component: () => import("/app/pages/dashboard/promuovi-ristorazione/index.vue")
  },
  {
    name: "dashboard-promuovi-ristorazione___en",
    path: "/en/dashboard/promuovi-ristorazione",
    meta: indexeRP9E5BCdVM39ttJXmipgIEgEg6tQnlO6i1kQ_FGAPUMeta || {},
    component: () => import("/app/pages/dashboard/promuovi-ristorazione/index.vue")
  },
  {
    name: "dashboard-promuovi-ristorazione___fr",
    path: "/fr/dashboard/promuovi-ristorazione",
    meta: indexeRP9E5BCdVM39ttJXmipgIEgEg6tQnlO6i1kQ_FGAPUMeta || {},
    component: () => import("/app/pages/dashboard/promuovi-ristorazione/index.vue")
  },
  {
    name: "dashboard-armonia-calendario-slug___it",
    path: "/it/dashboard/armonia/calendario/:slug()",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/armonia/calendario/[slug]/index.vue")
  },
  {
    name: "dashboard-armonia-calendario-slug___en",
    path: "/en/dashboard/armonia/calendario/:slug()",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/armonia/calendario/[slug]/index.vue")
  },
  {
    name: "dashboard-armonia-calendario-slug___fr",
    path: "/fr/dashboard/armonia/calendario/:slug()",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/armonia/calendario/[slug]/index.vue")
  },
  {
    name: "dashboard-armonia-calendario-slug-prenota___it",
    path: "/it/dashboard/armonia/calendario/:slug()/prenota",
    meta: {"middleware":["private-area-armonia-prenota"]},
    component: () => import("/app/pages/dashboard/armonia/calendario/[slug]/prenota.vue")
  },
  {
    name: "dashboard-armonia-calendario-slug-prenota___en",
    path: "/en/dashboard/armonia/calendario/:slug()/prenota",
    meta: {"middleware":["private-area-armonia-prenota"]},
    component: () => import("/app/pages/dashboard/armonia/calendario/[slug]/prenota.vue")
  },
  {
    name: "dashboard-armonia-calendario-slug-prenota___fr",
    path: "/fr/dashboard/armonia/calendario/:slug()/prenota",
    meta: {"middleware":["private-area-armonia-prenota"]},
    component: () => import("/app/pages/dashboard/armonia/calendario/[slug]/prenota.vue")
  },
  {
    name: "dashboard-profilo-card-abbonamenti-athena-id___it",
    path: "/it/dashboard/profilo/card/abbonamenti-athena/:id()",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/profilo/card/abbonamenti-athena/[id].vue")
  },
  {
    name: "dashboard-profilo-card-abbonamenti-athena-id___en",
    path: "/en/dashboard/profilo/card/abbonamenti-athena/:id()",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/profilo/card/abbonamenti-athena/[id].vue")
  },
  {
    name: "dashboard-profilo-card-abbonamenti-athena-id___fr",
    path: "/fr/dashboard/profilo/card/abbonamenti-athena/:id()",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/pages/dashboard/profilo/card/abbonamenti-athena/[id].vue")
  },
  {
    name: "visita-pianifica-la-tua-visita-torino-piemonte-card___it",
    path: "/it/visita/pianifica-la-tua-visita/torino-piemonte-card",
    meta: torino_45piemonte_45cardgl5EmiXCFD1YDSOt4JYBv2cCqm1PUfBMsdrR2LheVo4Meta || {},
    component: () => import("/app/pages/visita/pianifica-la-tua-visita/torino-piemonte-card.vue")
  },
  {
    name: "visita-pianifica-la-tua-visita-torino-piemonte-card___en",
    path: "/en/visit/plan-your-trip/torino-piemonte-card",
    meta: torino_45piemonte_45cardgl5EmiXCFD1YDSOt4JYBv2cCqm1PUfBMsdrR2LheVo4Meta || {},
    component: () => import("/app/pages/visita/pianifica-la-tua-visita/torino-piemonte-card.vue")
  },
  {
    name: "visita-pianifica-la-tua-visita-torino-piemonte-card___fr",
    path: "/fr/decouvrir/preparer-ton-sejour/torino-piemonte-card",
    meta: torino_45piemonte_45cardgl5EmiXCFD1YDSOt4JYBv2cCqm1PUfBMsdrR2LheVo4Meta || {},
    component: () => import("/app/pages/visita/pianifica-la-tua-visita/torino-piemonte-card.vue")
  },
  {
    name: "node-id___it",
    path: "/it/node/:id",
    meta: {"middleware":["search-node-redirect"]},
    component: () => import("/app/pages/node/[id].vue")
  },
  {
    name: "node-id___en",
    path: "/en/node/:id",
    meta: {"middleware":["search-node-redirect"]},
    component: () => import("/app/pages/node/[id].vue")
  },
  {
    name: "node-id___fr",
    path: "/fr/node/:id",
    meta: {"middleware":["search-node-redirect"]},
    component: () => import("/app/pages/node/[id].vue")
  },
  {
    name: "l-pagine-id___it",
    path: "/it/l/pagine/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/pagine/[id].vue")
  },
  {
    name: "l-pagine-id___en",
    path: "/en/l/pagine/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/pagine/[id].vue")
  },
  {
    name: "l-pagine-id___fr",
    path: "/fr/l/pagine/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/pagine/[id].vue")
  },
  {
    name: "l-risorse-id___it",
    path: "/it/l/risorse/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/risorse/[id].vue")
  },
  {
    name: "l-risorse-id___en",
    path: "/en/l/risorse/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/risorse/[id].vue")
  },
  {
    name: "l-risorse-id___fr",
    path: "/fr/l/risorse/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/risorse/[id].vue")
  },
  {
    name: "l-eventi-id___it",
    path: "/it/l/eventi/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/eventi/[id].vue")
  },
  {
    name: "l-eventi-id___en",
    path: "/en/l/eventi/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/eventi/[id].vue")
  },
  {
    name: "l-eventi-id___fr",
    path: "/fr/l/eventi/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/eventi/[id].vue")
  },
  {
    name: "l-prodotti-id___it",
    path: "/it/l/prodotti/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/prodotti/[id].vue")
  },
  {
    name: "l-prodotti-id___en",
    path: "/en/l/prodotti/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/prodotti/[id].vue")
  },
  {
    name: "l-prodotti-id___fr",
    path: "/fr/l/prodotti/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/prodotti/[id].vue")
  },
  {
    name: "l-attivita-id___it",
    path: "/it/l/attivita/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/attivita/[id].vue")
  },
  {
    name: "l-attivita-id___en",
    path: "/en/l/attivita/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/attivita/[id].vue")
  },
  {
    name: "l-attivita-id___fr",
    path: "/fr/l/attivita/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/attivita/[id].vue")
  },
  {
    name: "l-pacchetti-id___it",
    path: "/it/l/pacchetti/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/pacchetti/[id].vue")
  },
  {
    name: "l-pacchetti-id___en",
    path: "/en/l/pacchetti/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/pacchetti/[id].vue")
  },
  {
    name: "l-pacchetti-id___fr",
    path: "/fr/l/pacchetti/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/pacchetti/[id].vue")
  },
  {
    name: "l-news_convention-id___it",
    path: "/it/l/news_convention/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/news_convention/[id].vue")
  },
  {
    name: "l-news_convention-id___en",
    path: "/en/l/news_convention/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/news_convention/[id].vue")
  },
  {
    name: "l-news_convention-id___fr",
    path: "/fr/l/news_convention/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/news_convention/[id].vue")
  },
  {
    name: "l-visite_guidate-id___it",
    path: "/it/l/visite_guidate/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/visite_guidate/[id].vue")
  },
  {
    name: "l-visite_guidate-id___en",
    path: "/en/l/visite_guidate/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/visite_guidate/[id].vue")
  },
  {
    name: "l-visite_guidate-id___fr",
    path: "/fr/l/visite_guidate/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/visite_guidate/[id].vue")
  },
  {
    name: "l-spettacoli-id___it",
    path: "/it/l/spettacoli/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/spettacoli/[id].vue")
  },
  {
    name: "l-spettacoli-id___en",
    path: "/en/l/spettacoli/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/spettacoli/[id].vue")
  },
  {
    name: "l-spettacoli-id___fr",
    path: "/fr/l/spettacoli/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/pages/l/spettacoli/[id].vue")
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/it/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/fr/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  }
]